import api from './api'

export default {
  buscarQueries(body) {
    const config = {
      headers: { 'x-access-token': `${localStorage.getItem('tktaskcheck')}` }
    }
    return api().post('/sql/selecionar', body, config)
  },
  buscarQueryDBs(body) {
    const config = {
      headers: { 'x-access-token': `${localStorage.getItem('tktaskcheck')}` }
    }
    return api().post('/sql/db/selecionar', body, config)
  }
}